export default "__VITE_ASSET__CvCn5os8__"